import { createContext, useContext, useState } from "react";
import { AUTH_KEY as KEY, api, readSession, clearSession } from "@/lib/api";

const AuthContext = createContext(null);

// Login por e-mail e senha (POST /api/auth/login → JWT). A senha é definida pelo próprio usuário via link temporário
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(readSession);

  const login = async (email, password, remember) => {
    const { data } = await api.post("/auth/login", { email, password });
    const session = { ...data.user, token: data.token };
    clearSession();
    (remember ? localStorage : sessionStorage).setItem(KEY, JSON.stringify(session));
    setUser(session);
    return session;
  };
  const logout = () => {
    clearSession();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
